import AppTour from '@components/tour/AppTour';
import { TOUR_ID } from '@components/tour/tours';

/**
 * `AppTour` as the correction toolbar sees it: its button sits in the toolbar, beside ✕.
 *
 * It mounts with the toolbar, so its targets are there for the engine's once-on-mount check. No stages: it explains
 * the tools without choosing one, and the steps a screen lacks (the assistant while the analysis runs, Run again
 * without fixes or for the reindeer model) are dropped.
 *
 * - `suppressed` while a choice is half made — an add waiting for its confirmation, a detection's menu open: a mask
 *   over it would trap it.
 * - `onOpenChange` lets the page hold its correcting shortcuts (A, B, R, Esc, arrows) while the tour is open.
 */
const CorrectingTour = ({ suppressed = false, onOpenChange }) => (
	<AppTour
		tourId={TOUR_ID.VIDEO_CORRECTING}
		suppressed={suppressed}
		onOpenChange={onOpenChange}
	/>
);

export default CorrectingTour;
